import {
    SET_SORT_CATEGORY,
    SET_SORT_ORDER,
    SET_DOWNLOAD_SELECT_OPEN,
    SET_DOWNLOAD_PROPERTIES,
    SET_INSTITUTION_USERS_LIST,
} from "./actions";
import { initialState } from "./init";

export default HomeReducer;

function HomeReducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_SORT_CATEGORY:
            return setSortCategory(state, action);
        case SET_SORT_ORDER:
            return setSortOrder(state, action);
        case SET_DOWNLOAD_SELECT_OPEN:
            return setDownloadSelectOpen(state, action);
        case SET_DOWNLOAD_PROPERTIES:
            return setDownloadProperties(state, action);
        case SET_INSTITUTION_USERS_LIST:
            return setInstitutionUsersList(state, action);
        default:
            return state;
    }
}

function setSortCategory(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.currentSortCategory = action.category;
    return stateCpy;
}

function setSortOrder(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.currentSortOrder = action.order;
    return stateCpy;
}

function setDownloadSelectOpen(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.downloadProperties.selectActive = action.active;
    return stateCpy;
}

function setDownloadProperties(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.downloadProperties.selectActive = action.propt.selectOpen;
    stateCpy.downloadProperties.patientuuid = action.propt.patID;
    stateCpy.downloadProperties.planuuid = action.propt.planID;
    stateCpy.downloadProperties.pdfOnly = action.propt.pdfOnly;
    return stateCpy;
}

function setInstitutionUsersList(state, action) {
    let stateCpy = JSON.parse(JSON.stringify(state));
    stateCpy.institutionUsersList = action.institutionUsersList;
    return stateCpy;
}
